const CONSENT_KEY = 'cookieConsent';
const CONSENT_VERSION = '1';
const TWELVE_MONTHS_MS = 365 * 24 * 60 * 60 * 1000;

export interface CookieConsent {
    necessary: true;
    analytics: boolean;
    timestamp: number;
    version: string;
}

export const getConsent = (): CookieConsent | null => {
    try {
        const raw = localStorage.getItem(CONSENT_KEY);
        if (!raw) return null;
        return JSON.parse(raw) as CookieConsent;
    } catch {
        return null;
    }
};

export const hasValidConsent = (): boolean => {
    const consent = getConsent();
    if (!consent) return false;
    if (consent.version !== CONSENT_VERSION) return false;
    return Date.now() - consent.timestamp < TWELVE_MONTHS_MS;
};

export const setConsent = (analytics: boolean): void => {
    const consent: CookieConsent = {
        necessary: true,
        analytics,
        timestamp: Date.now(),
        version: CONSENT_VERSION,
    };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
};

export const hasAnalyticsConsent = (): boolean => {
    const consent = getConsent();
    return !!consent && consent.analytics && hasValidConsent();
};

export const clearConsent = (): void => {
    localStorage.removeItem(CONSENT_KEY);
};

export const initAnalytics = (): void => {
    import('./yandexMetrica').then(({ initYandexMetrica }) => initYandexMetrica());
};
